import { LIBRARY_IMPORT_MAP } from './libraryImportMap';

/**
 * UI 표시용 라이브러리 이름 (LIBRARY_IMPORT_MAP에서 자동 생성)
 *
 * @example
 * LIBRARY_DISPLAY_NAMES['numpy'] → 'numpy as np'
 * LIBRARY_DISPLAY_NAMES['plotly'] → 'plotly (px, go)'
 */
export const LIBRARY_DISPLAY_NAMES = Object.fromEntries(
  Object.entries(LIBRARY_IMPORT_MAP).map(([key, imports]) => {
    if (imports.length === 1) {
      const imp = imports[0];
      return [key, imp.alias ? `${imp.module.split('.')[0]} as ${imp.alias}` : key];
    }
    const aliases = imports.map((imp) => imp.alias).filter(Boolean);
    return [key, `${key} (${aliases.join(', ')})`];
  })
) as Record<string, string>;

/**
 * Monaco Editor용 import 구문 (LIBRARY_IMPORT_MAP에서 자동 생성)
 *
 * @example
 * LIBRARY_IMPORT_STATEMENTS['numpy'] → 'import numpy as np'
 * LIBRARY_IMPORT_STATEMENTS['plotly'] → 'import plotly.express as px\nimport plotly.graph_objects as go'
 */
export const LIBRARY_IMPORT_STATEMENTS = Object.fromEntries(
  Object.entries(LIBRARY_IMPORT_MAP).map(([key, imports]) => {
    const statements = imports.map((imp) =>
      imp.alias ? `import ${imp.module} as ${imp.alias}` : `import ${imp.module}`
    );
    return [key, statements.join('\n')];
  })
) as Record<string, string>;
